import type { ReactNode } from "react";
import { cx } from "../../../utils";

export const Checkbox = ({
  label,
  checked,
  disabled,
  name,
  id,
  onChange,
  className,
  labelClassName,
  wrapperClassName
}: {
  label?: ReactNode;
  checked?: boolean;
  id?: string;
  name?: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  wrapperClassName?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <label
      className={cx(
        "flex w-full items-center space-x-3 transition-all",
        wrapperClassName
      )}
    >
      <input
        checked={checked}
        className={cx(
          "text-primary-500 checked:disabled:bg-content-100 disabled:bg-background-900 h-5 w-5 rounded transition-all focus:ring-0 focus:ring-offset-0 disabled:cursor-not-allowed",
          checked && !disabled ? "border-primary-500" : "border-content-100",
          className
        )}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        type="checkbox"
      />
      {label ? (
        <span
          className={cx(
            "truncate text-sm font-medium font-medium transition-all",
            disabled ? "text-content-100" : "text-content-700",
            labelClassName
          )}
        >
          {label}
        </span>
      ) : null}
    </label>
  );
};
